import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const BackToAdminButton: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToAdmin = () => {
    navigate("/AdminMain"); 
  };

  return (
    <Button
      variant="text"
      startIcon={<ArrowBackIcon />} 
      onClick={handleBackToAdmin}
      sx={{
        color: "primary.main", 
        textTransform: "none", 
        fontSize: "16px",
      }}
    >
      トップページへ戻る
    </Button>
  );
};

export default BackToAdminButton;